import axios from '@/app/axios'
import Responses from '@/app/utils/responses'
import Question from '@/competences/entities/question'
import QuestionFilter from '@/competences/entities/question-filter'

class QuestionsService {
  public async findAllAsync(filter: QuestionFilter) {
    const res = await axios.post<Question[]>(`questions/filter`, filter)
    return Responses.list(res)
  }

  public async createAsync(entity: Question) {
    await axios.post<any>(`questions`, entity)
  }

  public async updateAsync(entity: Question) {
    await axios.put<any>(`questions`, entity)
  }

  public async removeAsync(id: string) {
    await axios.delete(`questions/${id}`)
  }

  public async downAsync(id: string) {
    await axios.post(`questions/down/${id}`)
  }
  public async upAsync(id: string) {
    await axios.post(`questions/up/${id}`)
  }
}

export default new QuestionsService()
